import { StatTile } from '../statTile'
import { usePayableClaims } from './usePayableClaims'
import s from './styles.module.scss'

interface Props {
    introducer: string
    title?: string
    // Optional PCP Referral campaign cohort ('current' | 'historical'); scopes
    // the payable claims to that window. Omit for all-time.
    cohort?: string
}

export const PayableClaimsProgress = ({ introducer, title = 'Payable Claims Progress', cohort }: Props) => {
    const { data, loading, error, reload } = usePayableClaims(introducer, true, cohort)

    return (
        <div className={s.statGroup}>
            <h3 className={s.statGroupTitle}>{title}</h3>

            <p className={s.subtitle}>
                Claims that meet the funding criteria and belong to payable clients. This can take a moment to
                calculate.
            </p>

            {loading && (
                <div className={s.loading}>
                    <span className={s.spinner} />
                    Calculating…
                </div>
            )}

            {!loading && error && (
                <div className={s.error}>
                    <span>{error}</span>
                    <button type="button" className={s.retry} onClick={reload}>
                        Retry
                    </button>
                </div>
            )}

            {!loading && !error && data && (
                <div className={s.statsContainer}>
                    <StatTile title="Total Claims" stat={`${data.totalClaims}`} />
                    <StatTile title="6 Year Claims" stat={`${data.sixYearClaims}`} />
                    <StatTile title="15 Year Claims" stat={`${data.fifteenYearClaims}`} />
                </div>
            )}
        </div>
    )
}

export default PayableClaimsProgress
